import React from "react";
//
import { Box } from "@mantine/core";
//
import { clsx } from "clsx";
import css from "./password-reset-card.module.css";

interface PasswordResetCardProps extends React.PropsWithChildren {
  className?: string;
}

export const PasswordResetCard = React.memo<PasswordResetCardProps>(
  function PasswordResetCard({ children, className }) {
    return (
      <Box className={clsx(css["pw-reset-card"], className)}>{children}</Box>
    );
  },
);
